import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store/Types';
import type { ThemeId } from "@volvo/vcdk";
const SLICE_NAME = 'navigation';

interface NavigationBarState {
  menuOpen: boolean;
  themeId: ThemeId;
}

export const initialNavigationBarState: NavigationBarState = {
  menuOpen: false,
  themeId: "volvo-light",
};

const navigationBarSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialNavigationBarState,
  reducers: {
    toggleMenu: (state, { payload: menuOpened }: PayloadAction<boolean>) => {
      state.menuOpen = menuOpened;
    },
    toggleTheme: (state, { payload: themeId }: PayloadAction<ThemeId>) => {
      state.themeId = themeId;
    },
  },
});

export const { toggleMenu, toggleTheme } = navigationBarSlice.actions;
export const selectMenuOpen = (state: RootState) => state.navigationBar.menuOpen;
export const selectThemeId = (state: RootState) => state.navigationBar.themeId;

export default navigationBarSlice.reducer;
